<template>
    <div class="registration-footer">
        <div v-if="authenticationStep == 'RegPersonal'" class="registration-footer__login">
            Již mám svůj účet.
            <a class="registration-footer__login-btn" @click="loginClickHandler">Chci se přihlásit.</a>
        </div>
        <button class="btn btn-secondary registration-footer__primary" @click="primaryClickHandler">{{ ctaText }}</button>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { AuthenticationStepType } from "@/account/models/authentication-flows";

const emit = defineEmits(["nextStep", "openLoginModal"]);

const props = defineProps<{
    authenticationStep: AuthenticationStepType;
}>();

const ctaText = computed(() => {
    switch (props.authenticationStep) {
        case "RegVerPhone":
        case "RegPinLog":
            return "Ověřit kód";
        case "RegNewPass":
            return "Uložit heslo";

        default:
            return "Pokračovat";
    }
});

const primaryClickHandler = () => {
    emit("nextStep");
};

const loginClickHandler = () => {
    emit("openLoginModal");
};
</script>
